import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdatePartnerDiscountState } from "./types";
import { IPartnerDiscount } from "@/shared/api/partners";

const initialState: UpdatePartnerDiscountState = {
    isCreatePartnerDiscountModalOpen: false,
    isUpdatePartnerDiscountModalOpen: false,
    isDeletePartnerDiscountModalOpen: false,

    currentDiscount: {
        accrual_type: 0,
        contract_id: "",
        started_date: "",
        created_date: "",
        finished_date: "",
        id: "",
        oem_groups: [],
        partner_id: "",
        value: 0,
        priority: 0
    },

    onCreate: null,
    onDelete: null,
    onUpdate: null
}

interface OpenCreateDiscountModal {
    onSuccess?: () => void
}

interface OpenUpdateDiscountModal {
    data: IPartnerDiscount
    onSuccess?: () => void
}

interface OpenDeleteDiscountModal {
    data: IPartnerDiscount
    onSuccess?: () => void
}

const updatePartnerDiscountSlice = createSlice({
    name: 'updatePartnerDiscount',
    initialState,
    reducers: {
        openCreatePartnerDiscountModal: (state, action: PayloadAction<OpenCreateDiscountModal>) => {
            state.isCreatePartnerDiscountModalOpen = true
            state.onCreate = action.payload.onSuccess
        },
        closeCreatePartnerDiscountModal: (state) => {
            state.isCreatePartnerDiscountModalOpen = false
        },
        openUpdatePartnerDiscountModal: (state, action: PayloadAction<OpenUpdateDiscountModal>) => {
            state.isUpdatePartnerDiscountModalOpen = true
            state.currentDiscount = action.payload.data
            state.onUpdate = action.payload.onSuccess
        },
        closeUpdatePartnerDiscountModal: (state) => {
            state.isUpdatePartnerDiscountModalOpen = false
        },
        openDeletePartnerDiscountModal: (state, action: PayloadAction<OpenDeleteDiscountModal>) => {
            state.isDeletePartnerDiscountModalOpen = true
            state.currentDiscount = action.payload.data
            state.onDelete = action.payload.onSuccess
        },
        closeDeletePartnerDiscountModal: (state) => {
            state.isDeletePartnerDiscountModalOpen = false
        },
    }
})

export default updatePartnerDiscountSlice.reducer
export const { 
    closeCreatePartnerDiscountModal,
    closeDeletePartnerDiscountModal,
    closeUpdatePartnerDiscountModal,
    openCreatePartnerDiscountModal,
    openDeletePartnerDiscountModal,
    openUpdatePartnerDiscountModal
} = updatePartnerDiscountSlice.actions